import React from 'react';
export function useOnline() {
    const onLine = React.useSyncExternalStore(onChange => {
        const listener = () => onChange();
        window.addEventListener('offline', listener);
        window.addEventListener('online', listener);
        return () => {
            window.removeEventListener('offline', listener);
            window.removeEventListener('online', listener);
        };
    }, () => navigator.onLine);
    return onLine;
}
